/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles(theme => ({
  icon: {
    borderRadius: '0.2rem',
    '-webkit-border-radius': '0.2rem',
    '-khtml-border-radius': '0.2rem',
    '-moz-border-radius': '0.2rem',
    width: '1rem',
    height: '1rem',
    backgroundColor: theme.palette.checkboxUnchecked,
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%,-50%)',
      width: '1.25rem',
      height: '1.25rem',
      border: `1px solid ${theme.palette.input}`,
      borderRadius: '0.3rem',
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.darkGray,
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: theme.palette.lightGray,
    },
    'input:hover:disabled ~ &': {
      background: theme.palette.lightGray,
    },
  },
  checkedIcon: {
    position: 'relative',
    width: '1.188rem',
    height: '1.188rem',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '0.2rem',
    '&::after': {
      content: '""',
      top: '42%',
      left: '53%',
      width: '.75rem',
      height: '.35rem',
      position: 'absolute',
      transform: 'translate(-50%, -50%) rotate(-45deg)',
      borderLeft: '0.15rem solid white',
      borderBottom: '0.15rem solid white',
    },
  },
}));

export default function CustomCheckbox(props) {
  const classes = useStyles();

  return (
    <Checkbox
      color="primary"
      checkedIcon={<span className={classes.checkedIcon} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}
